import { useMutation } from "@tanstack/react-query"
import { insertBcInfo } from "@/api"

export const useInsertBc = () => {
  return useMutation({
    mutationFn: ({
      dealId,
      legalName,
      email,
      address,
      city,
      state,
      zip,
      phone,
      birthDate,
      ssn,
      isMarried,
      isUsCitizen,
      spouseName,
      spouseEmail,
    }: {
      dealId: number
      legalName: string
      email: string
      address: string
      city: string
      state: string
      zip: string
      phone: string
      birthDate: string
      ssn: string
      isMarried: string
      isUsCitizen: string
      spouseName: string
      spouseEmail: string
    }) =>
      insertBcInfo({
        dealId,
        legalName,
        email,
        address,
        city,
        state,
        zip,
        phone,
        birthDate,
        ssn,
        isMarried,
        isUsCitizen,
        spouseName,
        spouseEmail
      }),
  })
}